/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab.ts";

function getGetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabUrl(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabPathParams["courseRegistrationId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/enrollment/${courseRegistrationId}/history-tab` as const,
  };
  return res;
}

/**
 * @description Retorna a lista de alterações de status com motivo, submotivo, observação, data e usuário responsável, para exibição na aba Histórico do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna o histórico de status de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/history-tab}
 */
export async function getApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTabUrl(
      courseRegistrationId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
